import React, { useEffect, useState } from "react";

import { Marker, InfoWindow, MarkerClusterer } from "@react-google-maps/api";

import { defaultMarker } from "../Icons";
import { useAllContexts } from "../../../../hooks/useAllContexts";
import { formatMapData } from "../../helpers";

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
};

const BaseCluster = ({
  data,
  categoryId,
  selectedCategory,
  openInfoWindow,
  selectedItem,
  center,
  zoomLevel,
  rightSideBox,
  showNewRoute,
}) => {
  const [clusterData, setClusterData] = useState(null);
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  const { newRouteData } = useAllContexts();

  // useEffect(() => {
  //   center.set({
  //     lat: 40.653582,
  //     lng: 22.922504,
  //   });
  //   zoomLevel.set(15);
  // }, [selectedCategory, categoryId]);

  useEffect(() => {
    const tempData = data?.map((item) => {
      return formatMapData(
        categoryId,
        item,
        selectedCategory === "infra" || showNewRoute ? true : false
      );
    });
    setClusterData(tempData);

    return () => {
      setClusterData(null);
    };
  }, [data]);

  useEffect(() => {
    if (selectedItem.getItem) {
      center.set({
        lat: parseFloat(
          selectedItem?.getItem?.latitude ?? selectedItem?.getItem?.lat
        ),
        lng: parseFloat(
          selectedItem?.getItem?.longitude ?? selectedItem?.getItem?.lng
        ),
      });
      zoomLevel.set(21);
      setActiveMarkerId(
        selectedItem?.getItem?.id ?? selectedItem?.getItem?.mysensor_id
      );
      openInfoWindow.set(true);
    } else {
      center.set({
        lat: 40.653582,
        lng: 22.922504,
      });
      zoomLevel.set(15);
    }
  }, [selectedItem.getItem]);

  return (
    <MarkerClusterer options={options} averageCenter>
      {(clusterer) => {
        return clusterData.map((marker) => {
          return (
            <Marker
              noRedraw={true}
              key={`marker_${marker?.id ?? marker?.mysensor_id}`}
              position={
                marker?.position ?? {
                  lat: parseFloat(marker?.lat),
                  lng: parseFloat(marker?.lng),
                }
              }
              clickable
              clusterer={clusterer}
              icon={marker?.icon ?? defaultMarker}
              onClick={() => {
                console.log("TEST: openInfoWindow:", openInfoWindow, marker.id);
                openInfoWindow.set(true);
                const tempItem = data.filter(
                  (item) =>
                    (categoryId === "122" ? item?.id : item?.mysensor_id) ===
                    marker?.id
                )[0];

                selectedItem.setItem(tempItem);
                center.set(marker.position);
                zoomLevel.set(21);
                if (
                  (categoryId === "122" &&
                    selectedCategory === "routes" &&
                    !showNewRoute) ||
                  categoryId === "31"
                ) {
                  if (!rightSideBox.isVisible) {
                    rightSideBox.setIsVisible(!rightSideBox.isVisible);
                  }
                }
                setActiveMarkerId(marker?.id);
              }}
            >
              {openInfoWindow.get && activeMarkerId === marker.id && (
                <InfoWindow
                  position={
                    marker?.position ?? {
                      lat: parseFloat(marker?.lat),
                      lng: parseFloat(marker?.lng),
                    }
                  }
                  onCloseClick={() => {
                    openInfoWindow.set(false);
                    center.set({
                      lat: 40.653582,
                      lng: 22.922504,
                    });
                  }}
                >
                  <div style={{ width: "fit-content", paddingInline: "30px" }}>
                    <p>{marker?.title}</p>
                    <p>{marker?.subTitle}</p>
                    {showNewRoute && (
                      <>
                        <hr
                          style={{
                            border: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.25)",
                          }}
                        />
                        <p
                          style={{
                            textAlign: "right",
                            fontWeight: "400",
                            color: "blue",
                            cursor: "pointer",
                            marginTop: "6px",
                            borderRadius: "12px",
                          }}
                          onClick={() => {
                            openInfoWindow.set(false);
                            newRouteData?.set("step", marker);
                            zoomLevel.set(15);
                            center.set({
                              lat: 40.653582,
                              lng: 22.922504,
                            });
                          }}
                        >
                          Επιλογή Υποδομής
                        </p>
                      </>
                    )}
                  </div>
                </InfoWindow>
              )}
            </Marker>
          );
        });
      }}
    </MarkerClusterer>
  );
};

export default BaseCluster;
